export default __webpack_public_path__ + "static/media/404-page-light.1638927c.png";